'use client';

export default function Mission() {
  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-white to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
          <div>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
              Our Mission & Philosophy
            </h2>
            
            <p className="text-base sm:text-lg md:text-xl text-gray-700 mb-8 leading-relaxed">
              At AyurVeda, we believe that true wellness comes from understanding and working 
              with your body's natural wisdom. Our mission is to make authentic Ayurvedic 
              healing accessible to everyone, everywhere.
            </p>

            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0">
                  <i className="ri-leaf-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">Authentic Formulations</h3>
                  <p className="text-sm sm:text-base text-gray-700">
                    Every product is crafted using traditional Ayurvedic principles and time-tested recipes 
                    passed down through generations of healers.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0">
                  <i className="ri-shield-check-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">Quality Assurance</h3>
                  <p className="text-sm sm:text-base text-gray-700">
                    We source the finest organic herbs and use rigorous testing to ensure purity, 
                    potency, and safety in every product.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0">
                  <i className="ri-heart-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">Holistic Approach</h3>
                  <p className="text-sm sm:text-base text-gray-700">
                    We focus on treating the root cause, not just symptoms, promoting overall 
                    balance and long-term wellness.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <img 
              src="https://readdy.ai/api/search-image?query=Traditional%20ayurvedic%20medicine%20preparation%20with%20mortar%20and%20pestle%2C%20fresh%20herbs%2C%20turmeric%2C%20ginger%2C%20neem%20leaves%2C%20ancient%20wisdom%20setup%2C%20natural%20lighting%2C%20warm%20earthy%20tones%2C%20professional%20wellness%20photography%2C%20authentic%20ingredients%20display&width=600&height=500&seq=mission1&orientation=landscape"
              alt="Ayurvedic Medicine Preparation"
              className="rounded-2xl shadow-2xl w-full h-96 object-cover"
            />
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl p-6 max-w-xs">
              <div className="flex items-center space-x-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center bg-green-100 rounded-full">
                  <i className="ri-award-line text-green-600"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900">Certified Organic</div>
                  <div className="text-sm text-gray-600">100% Natural Ingredients</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}